<template>
    <v-menu bottom left offset-y origin="top left" v-if="isAdmin" @input="closeAutoImportsLog">
        <template v-slot:activator="{ attrs, on }">
            <v-btn class="ml-1" min-width="0" text v-bind="attrs" v-on="on">
                <v-badge :color="healthSystemRed ? 'red' : 'yellow'" overlap bordered
                    v-if="healthSystemRed || healthSystemYellow" :class="healthSystemRed ? 'flashing' : ''">
                    <template v-slot:badge> </template>
                    <v-icon>mdi-dns</v-icon>
                </v-badge>
                <v-icon v-if="!healthSystemRed && !healthSystemYellow">mdi-dns</v-icon>
            </v-btn>
        </template>
        <v-list flat tile class="pa-0 ma-0">
            <v-list-item v-for="system in healthSystems" :key="system.name" style="min-width: 250px">
                <v-list-item-content class="system-item py-0">
                    <v-col cols="8 pl-0">{{ system.name }}</v-col>
                    <v-col cols="2 ps-5">
                        <v-icon v-if="system.name == 'AutoImport' && system.statusName == 'red'"
                            :color="system.statusName" @click.stop="toggleAutoImportLog">mdi-eye</v-icon>
                    </v-col>
                    <v-col cols="2 px-0" class="text-right">
                        <v-icon :color="system.statusName">mdi-circle</v-icon>
                    </v-col>
                </v-list-item-content>
            </v-list-item>
            <template v-if="showAutoImportLog && healthSystems[indexAutoImports]">
                <v-list-item
                    v-for="(log, i) in healthSystems[indexAutoImports].autoImportsStatus"
                    :key="`${healthSystems[indexAutoImports].name}-${i}`"
                >
                    <v-list-item-content>
                    <li class="cursor-pointer" @click="redirectToContentTypes(log)">{{ log.ContentTypeName + ' | ' + log.NameProvider }}</li>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-menu>
</template>
<script>

import HealthSystemsService from '@/services/HealthSystemsService';
import HealthSystem from '@/ecm/models/healthSystems/HealthSystem';

export default {
    name: 'HealthStatusIcon',
    data() {
        return {
            healthSystems: [],
            healthSystemYellow: false,
            healthSystemRed: false,
            showAutoImportLog: false,
            indexAutoImports: 0
        };
    },
    created() {
        this.getHealthSystems();
    },
    methods: {
        getHealthSystems() {
            HealthSystemsService.getHealthSystemStatus().then(data => {
                this.healthSystems = data.map(function (dto) {
                    return new HealthSystem(dto);
                });
                this.healthSystems.sort((a, b) => {
                    if (a.name === 'AutoImport') return 1;
                    if (b.name === 'AutoImport') return -1;
                    return a.name.localeCompare(b.name);
                });
                this.healthSystemRed = this.healthSystems.some(x => x.status === 2);
                this.healthSystemYellow = this.healthSystems.some(x => x.status === 1);
            });
        },
        isAdmin() {
            return this.user && (this.user.IsAdmin || this.user.SysLevel == 2);
        },
        toggleAutoImportLog() {
            this.showAutoImportLog = !this.showAutoImportLog;
            this.indexAutoImports = this.healthSystems.findIndex(x => x.name == 'AutoImport');
        },
        closeAutoImportsLog() {
            this.showAutoImportLog = false;
        },
        redirectToContentTypes(log) {
            const routeTo = this.$router.resolve({
                name: 'AutoImportConfig',
                params: { id: log.ContentTypeId }
            });

            if (this.$router.currentRoute.path !== routeTo.href) {
                this.$router.push({
                    name: 'AutoImportConfig',
                    params: {
                        id: log.ContentTypeId
                    }
                });
            }
        },
    }
};

</script>
